'use client'

import { ThemeProvider } from '@quark/theme'
import React, { useEffect, useState } from 'react'
import UserServiceApi from '@services/userService'
import { useHybridIsMobile } from '@utils/fallbackIsMobile'
import DesktopHeader from './Desktop'
import HeaderMobile from './Mobile'

const HomeHeader = React.memo((props: any) => {
  const [userData, setUserData] = useState<any>(false)
  const isMobile = useHybridIsMobile(props.isMobile)

  useEffect(() => {
    if (props.isLoggedIn) {
      UserServiceApi.getUserDetails()
        .then(userDetail => {
          const data = {
            email: userDetail.email,
            name: userDetail.name.split(' ')[0],
            phone: userDetail.phone,
            gender: userDetail.gender,
            avatar: userDetail.name.charAt(0),
          }
          setUserData(data)
        })
        .catch(err => {
          console.log('CATCH USER DETAILS ERROR : ', err)
        })
    }
  }, [props.isLoggedIn])
  return (
    <ThemeProvider brand="DEFAULT" theme="LIGHT">
      {!isMobile ? (
        <DesktopHeader
          isLoggedIn={props.isLoggedIn && userData}
          userData={userData}
          content={props.data}
          animate={props.animate}
        />
      ) : (
        <HeaderMobile
          isLoggedIn={props.isLoggedIn && userData}
          userData={userData}
          content={props.data}
          animate={props.animate}
        />
      )}
    </ThemeProvider>
  )
})

export default HomeHeader
